import React from "react";
import { Navigate, useRoutes } from 'react-router-dom';
import Home from "../components/Home";
import Docs from "../components/Docs";
import Error404 from '../components/Error/404';
import Login from '../components/auth/Login';
import Logout from '../components/auth/Logout';
import ResetPassword from '../components/auth/ResetPassword';
import Account from '../components/settings/Account';
import APIKeys from '../components/settings/APIKeys';
import Organizations from '../components/settings/Organizations';
import Profile from '../components/settings/Profile';
import Projects from '../components/settings/Projects';
import Solutions from '../components/Solutions'
import SolutionView from '../components/Solutions/SolutionView';
import UserPage from '../components/UserPage';
import Equations from '../components/admin/Equations';
import FeaturedSolutions from '../components/admin/FeaturedSolutions';
import SolutionsDashboard from '../components/admin/SolutionsDashboard';
import AdminUsers from '../components/admin/Users';
import AdminEditSolution from '../components/admin/AdminEditSolution';
import UseCases from '../components/admin/UseCases';
import About from '../components/About'
import Privacy from '../components/Privacy'
import Terms from '../components/Terms'
import Competitions from '../components/Competitions';
import Pricing from '../components/Pricing';
import Contact from '../components/Contact';
import NeuroDiffEqAgent from '../components/NeuroDiffEqAgent';
import RequireAuth from '../components/auth/RequireAuth';
import ForceLoginGate from '../components/auth/ForceLoginGate';
import withRouter from "../utils/withRouter";

const HomeWithRouter = withRouter(Home);
const DocsWithRouter = withRouter(Docs);
const SolutionsWithRouter = withRouter(Solutions);
const SolutionViewWithRouter = withRouter(SolutionView);
const UserPageWithRouter = withRouter(UserPage);
const LoginWithRouter = withRouter(Login);
const LogoutWithRouter = withRouter(Logout);
const ResetPasswordWithRouter = withRouter(ResetPassword);
const AccountWithRouter = withRouter(Account);
const APIKeysWithRouter = withRouter(APIKeys);
const OrganizationsWithRouter = withRouter(Organizations);
const ProfileWithRouter = withRouter(Profile);
const ProjectsWithRouter = withRouter(Projects);
const EquationsWithRouter = withRouter(Equations);
const FeaturedSolutionsWithRouter = withRouter(FeaturedSolutions);
const SolutionsDashboardWithRouter = withRouter(SolutionsDashboard);
const AdminUsersWithRouter = withRouter(AdminUsers);
const AdminEditSolutionWithRouter = withRouter(AdminEditSolution);
const UseCasesWithRouter = withRouter(UseCases);
const AboutWithRouter = withRouter(About);
const PrivacyWithRouter = withRouter(Privacy);
const TermsWithRouter = withRouter(Terms);
const CompetitionsWithRouter = withRouter(Competitions);
const PricingWithRouter = withRouter(Pricing);
const ContactWithRouter = withRouter(Contact);
const NeuroDiffEqAgentWithRouter = withRouter(NeuroDiffEqAgent);
const Error404WithRouter = withRouter(Error404);


const AppRouter = (props) => {
  const routes = [
    { path: "/", element: <HomeWithRouter /> },
    { path: "/solutions", element: <SolutionsWithRouter /> },
    { path: "/solutions/:id", element: <SolutionViewWithRouter /> },
    { path: "/competitions", element: <CompetitionsWithRouter /> },
    { path: "/pricing", element: <PricingWithRouter /> },
    { path: "/contact", element: <ContactWithRouter /> },
    {
      path: "/pinns-agent",
      element: (
        <RequireAuth>
          <NeuroDiffEqAgentWithRouter />
        </RequireAuth>
      ),
    },
    { path: "/neurodiffeq-agent", element: <Navigate to="/pinns-agent" replace /> },
    { path: "/user/:username", element: <UserPageWithRouter /> },
    { path: "/signup", element: <Navigate to="/login" replace /> },
    { path: "/login", element: <LoginWithRouter /> },
    { path: "/reset_password", element: <ResetPasswordWithRouter /> },
    { path: "/logout", element: <LogoutWithRouter /> },
    { path: "/docs/:page", element: <DocsWithRouter /> },
    { path: "/about", element: <AboutWithRouter /> },
    { path: "/privacy", element: <PrivacyWithRouter /> },
    { path: "/terms", element: <TermsWithRouter /> },
    {
      path: "/settings/account",
      element: (
        <RequireAuth>
          <AccountWithRouter />
        </RequireAuth>
      ),
    },
    {
      path: "/settings/profile",
      element: (
        <RequireAuth>
          <ProfileWithRouter />
        </RequireAuth>
      ),
    },
    {
      path: "/settings/apikeys",
      element: (
        <RequireAuth>
          <APIKeysWithRouter />
        </RequireAuth>
      ),
    },
    {
      path: "/settings/organizations",
      element: (
        <RequireAuth>
          <OrganizationsWithRouter />
        </RequireAuth>
      ),
    },
    {
      path: "/settings/projects",
      element: (
        <RequireAuth>
          <ProjectsWithRouter />
        </RequireAuth>
      ),
    },
    {
      path: "/admin/equations",
      element: (
        <RequireAuth>
          <EquationsWithRouter />
        </RequireAuth>
      ),
    },
    {
      path: "/admin/featuredsolutions",
      element: (
        <RequireAuth>
          <FeaturedSolutionsWithRouter />
        </RequireAuth>
      ),
    },
    {
      path: "/admin/solutionsdashboard",
      element: (
        <RequireAuth>
          <SolutionsDashboardWithRouter />
        </RequireAuth>
      ),
    },
    {
      path: "/admin/usecases",
      element: (
        <RequireAuth>
          <UseCasesWithRouter />
        </RequireAuth>
      ),
    },
    {
      path: "/admin/users",
      element: (
        <RequireAuth>
          <AdminUsersWithRouter />
        </RequireAuth>
      ),
    },
    {
      path: "/admin/admins",
      element: <Navigate to="/admin/users" replace />,
    },
    {
      path: "/admin/solutions/edit/:id",
      element: (
        <RequireAuth>
          <AdminEditSolutionWithRouter />
        </RequireAuth>
      ),
    },
    { path: "*", element: <Error404WithRouter /> },
  ];

  const element = useRoutes(routes);

  return <ForceLoginGate>{element}</ForceLoginGate>;
}

export default AppRouter;
